import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TableHead,
  Skeleton,
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { Link } from "react-router-dom";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const recentAppsSample = [
  {
    name: "Google Drive",
    project: "SkyGrid",
    icon: "https://upload.wikimedia.org/wikipedia/commons/1/1f/Google_Drive_icon_(2020).svg",
    duration: "01:40",
  },
  {
    name: "Figma",
    project: "Project Quantum",
    icon: "https://cdn.worldvectorlogo.com/logos/figma-1.svg",
    duration: "00:40",
  },
  {
    name: "Adobe Illustrator 2024",
    project: "Digital Marketing",
    icon: "https://cdn.worldvectorlogo.com/logos/adobe-illustrator-cc-icon.svg",
    duration: "02:30",
  },
  {
    name: "Windows Explorer",
    project: "Project Quantum",
    icon: "",
    duration: "03:15",
  },
  {
    name: "Microsoft Excel 2016",
    project: "SkyGrid",
    icon: "https://cdn.worldvectorlogo.com/logos/microsoft-excel-2013.svg",
    duration: "03:15",
  },
];

// Skeleton loader component with numbering
const TableRowsLoader = ({ rowsNum }) => {
  return [...Array(rowsNum)].map((_, index) => (
    <TableRow key={index}>
      {/* Numbering Skeleton */}
      <TableCell>
        <Skeleton animation="wave" variant="text" width={20} />
      </TableCell>

      {/* Avatar + Text Skeleton */}
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton
              variant="rectangular"
              width={150}
              height={8}
              sx={{ borderRadius: 4, mt: 1 }}
            />
          </Box>
        </Box>
      </TableCell>

      {/* Duration Skeleton */}
      <TableCell align="right">
        <Skeleton variant="text" width={60} />
      </TableCell>
    </TableRow>
  ));
};

const RecentAppActivity = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setData(recentAppsSample);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Paper className="card-body p-20 bg-base border rounded-3 h-100" sx={{ boxShadow: 'none' }}>
      <Box display="flex" justifyContent="space-between" className=" pb-16 mb-0 border-bottom" sx={{ flexWrap: { sm: 'wrap' } }}>
        <h6 className=" fw-semibold mb-0" style={{fontSize: '17px'}}>Recent Application Activity  <Tooltip title="Recent Application Activity" arrow placement="top">
          <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
            <InfoOutlineIcon fontSize="small" />
          </button>
        </Tooltip></h6>
         <a href="/apps" style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}>
          View report
        </a>
       
          {/* <Link to="/apps"
            style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}
          >
            View report
          </Link> */}

      </Box>

      <TableContainer>
        <Table className="tablegridall">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell> {/* Serial number header */}
              <TableCell>Application</TableCell>
              <TableCell align="right">Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "none", // 🔥 remove table body cell borders
              },
            }}
          >
            {!data ? (
              <TableRowsLoader rowsNum={5} />
            ) : (
              data.map((app, index) => (
                <TableRow key={index}>
                  {/* Numbering */}
                  <TableCell>{index + 1}</TableCell>

                  {/* App Icon and Name + Project */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      {app.icon ? (
                        <Avatar src={app.icon} alt={app.name} />
                      ) : (
                        <Avatar sx={{ bgcolor: "#90a4ae", fontSize: '14px' }}>
                          {app.name
                            .split(" ")
                            .map((word) => word[0])
                            .join("")
                            .slice(0, 2)
                            .toUpperCase()}
                        </Avatar>
                      )}
                      <Box>
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600, color: '#1A1F36', }}>{app.name}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {app.project}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  {/* Duration */}
                  <TableCell align="right">
                    <Typography variant="body2">{app.duration}</Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default RecentAppActivity;
